// src/components/ShippingPolicy.jsx

import React from 'react';
import { Link } from 'react-router-dom';

const SECTIONS = [
  {
    title: 'مدة الشحن',
    tone: 'yolk',
    body: (
      <>تختلف مدة الشحن حسب موقع التوصيل. عادة ما تتراوح مدة الشحن داخل المدن الرئيسية في المملكة العربية السعودية بين <strong className="font-bold text-[#1B1B1F]">3-5 أيام عمل</strong>. بالنسبة للمناطق النائية، قد يستغرق التوصيل وقتًا أطول.</>
    )
  },
  {
    title: 'رسوم الشحن',
    tone: 'ink',
    list: [
      <>تطبق رسوم شحن ثابتة قدرها <strong className="font-bold text-[#1B1B1F]">25 ريال سعودي</strong> على جميع الطلبات.</>,
      <>الشحن مجاني للطلبات التي تزيد قيمتها عن <strong className="font-bold text-[#1B1B1F]">250 ريال سعودي</strong>.</>,
      <>قد تختلف الرسوم للطلبات الدولية (إن وجدت).</>
    ]
  },
  {
    title: 'شركات الشحن',
    tone: 'yolk',
    body: (
      <>نتعاون مع أفضل شركات الشحن المحلية والعالمية لضمان وصول طلباتكم بسلام. تشمل شركات الشحن التي نتعامل معها: <strong className="font-bold text-[#1B1B1F]">أرامكس، سمسا، وناقل</strong>.</>
    )
  },
  {
    title: 'تتبع الطلب',
    tone: 'ink',
    body: (
      <>بمجرد شحن طلبك، سيتم إرسال بريد إلكتروني يحتوي على رقم تتبع الشحنة. يمكنك استخدام هذا الرقم لتتبع حالة طلبك مباشرة على موقع شركة الشحن.</>
    )
  }
];

const ShippingPolicy = () => {
  return (
    <div className="relative container mx-auto p-8 md:p-16" dir="rtl">

      {/* زر العودة إلى الرئيسية */}
      <div className="absolute top-8 left-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold
            bg-[#F2B705] text-[#1B1B1F] hover:bg-[#1B1B1F] hover:text-white
            transition-colors duration-200 shadow-sm
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2"
        >
          العودة إلى الرئيسية
          <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
      </div>

      {/* قسم العنوان والمقدمة */}
      <div className="text-center mb-16 pt-16 md:pt-0">
        <span
          className="inline-block px-4 py-1 rounded-full bg-[#F2B705]/15 text-[#1B1B1F] text-sm font-bold -rotate-2 mb-4"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          #الشحن_والتوصيل
        </span>
        <h1
          className="text-4xl md:text-6xl font-extrabold text-[#1B1B1F] mb-4"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          سياسة الشحن والتوصيل
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          نسعى لتوصيل طلباتكم بأسرع وقت ممكن وبأفضل خدمة. إليكم تفاصيل سياسة الشحن والتوصيل الخاصة بمتجرنا.
        </p>
      </div>

      {/* أقسام السياسة */}
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)]">
        <div className="space-y-10">
          {SECTIONS.map((section) => (
            <div
              key={section.title}
              className={`pr-4 ${section.tone === 'yolk' ? 'border-r-4 border-[#F2B705]' : 'border-r-4 border-[#1B1B1F]'}`}
            >
              <h2
                className="text-2xl font-bold text-[#1B1B1F] mb-3"
                style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
              >
                {section.title}
              </h2>
              {section.body && (
                <p className="text-gray-700 leading-relaxed text-right">{section.body}</p>
              )}
              {section.list && (
                <ul className="list-disc text-gray-700 leading-relaxed space-y-3 pr-6">
                  {section.list.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
